export default {
  setFeatures(state, features) {
    state.features = features
  },
}
